import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationMenuNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M4 13h40v1H4v-1zm0 10.5h40v1H4v-1zM4 34h40v1H4v-1z"
      />
    </svg>
  )
);
SvgNavigationMenuNormalLarge.defaultProps = {
  color: "currentColor",
  size: 48,
  title: undefined,
  titleId: undefined,
};
SvgNavigationMenuNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationMenuNormalLarge;
